// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"styles---bannerWrapper---yATPR","banner":"styles---banner---q64Ok"};